// extracted by mini-css-extract-plugin
module.exports = {"root":"AskList_root__vy6ns","title_text":"AskList_title_text__YDGnu"};